import React, { useCallback, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, SensorNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { DiamondNodePropsType } from "./FlowchartTypes";

const DiamondNode: React.FC<DiamondNodePropsType> = ({ id, data }) => {

    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };
    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`sensor-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <div className={`container`}>
                <SensorNodeIcon width='1.5rem'/>
                <span className={`name`}>{data.label}</span>
                <span className={`sensor`}>{data.data.criteria}</span>
                <span className={`sensor`}>{data.data.interval}s</span>
                {isHovering && (
                    <div className={`node-close-ico`} onClick={deleteNode}>
                        <CloseIcon width='1rem' color="var(--color-main-red)"/>
                    </div>
                )}
                
            </div>
            <Handle id="dimo-target-a" type="target" position={Position.Top} style={{...targetCustomStyles, background: "blue", left: '0'}}/>
            <Handle id="yes" type="source" position={Position.Right} style={{...targetCustomStyles, background: "green", top: '0'}}/>
            <Handle id="no" type="source" position={Position.Left} style={{...sourceCustomStyles, background: "red", top: '100%'}}/>
            <Handle id="dimo-source-a" type="source" position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow", left: '100%'}}/>
        </div>
    );
};

export default DiamondNode;
